export const AGREE_DECLINE  = 'AGREE_DECLINE';
export const AGREE = 'AGREE';
export const AGREE_LINK = 'AGREE_LINK';

export const showCheckAction = () => ({
      type: AGREE_DECLINE,
      payload:{checked:true}        
})

export const changeCheckAction = value => ({
    type: AGREE,
    payload:{checked:value}    
})

export const  changeCheckLinkAction = () => ({
    type: AGREE_LINK,
    payload:{checked:true}    
})